import { request } from "../network/request";
const db = "dn0";
//查询绩效管家大事记列表
export function getDsjList(params) {
  return request({
    url: "pmp/kh/dsjList",
    method: "get",
    params: {
      db,
      ...params,
    },
  });
}

// 导出绩效管家大事记列表
export function exportDsjList(params) {
  return request({
    url: "pmp/kh/exportDsjList",
    method: "get",
    params: {
      db,
      ...params,
    },
  });
}

// 删除绩效管家大事记
export function deleteDsj(id) {
  return request({
    url: 'pmp/kh/deleteDsjById',
    method: 'get',
    params: { id: id },
  })
}


//新增/编辑绩效管家大事记
export function saveDsj(params) {
  return request({
    url: "pmp/kh/saveDsj",
    method: "post",
    data: params,
  });
}


/**
 * 绩效管家大事记-编辑
 * @param {*} params 
 * @returns 
 */
export function getDsjById(params) {
  return request({
    url: "pmp/kh/getDsjById",
    method: "get",
    params,
  });
}

/**
 * 绩效管家大事记获取项目信息-新增
 * @param {*} params
 * @returns
 */
export function getDsjXmxx(params) {
    return request({
        url: "pmp/kh/getDsjXmxx",
        method: "get",
        params,
    });
}